export const isLogin="isLogin"
export const isModal="isModal"